import { Dashboard } from '@ih/app/shared/apis/interfaces';

export class SetDashboards {
  public static readonly type = '[Project/Dashboard/List] SetDashboards';
  constructor(public readonly dashboards: Dashboard[]) {}
}
